import styled, { DefaultTheme, keyframes } from "styled-components";

interface IStyles {
    theme?: DefaultTheme;
}

const TOOLTIP_LENGTH = 6;

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const FadeInAnimation = styled.div`
    animation: ${fadeIn} 0.1s ease-in;
`;

export const Container = styled(FadeInAnimation)(({ theme }) => {
    return {
        position: "fixed",
        top: `calc(${TOOLTIP_LENGTH}px * -1)`,
        left: `calc(${theme.spacing.xxLarge} * -1)`,
        zIndex: "1",
        padding: `${theme.spacing.large} ${theme.spacing.medium}`,
        background: theme.colors[theme.colorMode].background_Primary,
        borderRadius: theme.spacing.small,
        boxShadow: " 0px 1px 16px rgba(2, 6, 12, 0.08)",
    };
});

export const Before = styled.div<IStyles>(({ theme }) => {
    return {
        position: "absolute",
        bottom: `calc(${theme.spacing.xxxSmall} * -1)`,
        width: "14px",
        height: "14px",
        background: theme.colors[theme.colorMode].background_Primary,
        transform: "rotate(-60deg) skew(-30deg)",
        boxShadow: "0px 1px 16px rgba(2, 6, 12, 0.08)",
        zIndex: "1",
    };
});

export const After = styled.div<IStyles>(({ theme }) => {
    return {
        position: "absolute",
        bottom: "0",
        width: "25px",
        height: "16px",
        background: theme.colors[theme.colorMode].background_Primary,
        zIndex: "2",
    };
});
